// contactCommHelpers.ts — Gemeinsames Mapping der getrennten Personen-
// Kommunikationsfelder (Telefon/Mobil/E-Mail je privat/geschäftlich) auf
// ContactCommunication-Einträge (type + label + kind). Identische Konvention
// wie in buildPrivateContactCreatePayload: type='phone'|'mobile'|'email',
// label='Privat'|'Geschäftlich' (Anzeige), kind='privat'|'geschaeftlich'
// (strukturierte Art, SP1); das erste Telefon-artige und das erste
// E-Mail-Feld werden isDefault. Wiederverwendet von der Inline-Anlage
// (ContactRefField/persistRelations + RelationContactPicker).

export type CommItem = { type: string; label?: string; kind?: string; value: string; isDefault?: boolean };

/** Getrennte Personen-Felder (privat/geschäftlich) für Telefon/Mobil/E-Mail. */
export type PersonCommFields = {
  phonePrivate?: string;
  phoneWork?: string;
  mobilePrivate?: string;
  mobileWork?: string;
  emailPrivate?: string;
  emailWork?: string;
  phone?: string;
  mobile?: string;
  email?: string;
};

const PERSON_COMM_SPECS: Array<{ type: string; label: string; kind: string; key: keyof PersonCommFields }> = [
  { type: "phone", label: "Privat", kind: "privat", key: "phonePrivate" },
  { type: "phone", label: "Geschäftlich", kind: "geschaeftlich", key: "phoneWork" },
  { type: "mobile", label: "Privat", kind: "privat", key: "mobilePrivate" },
  { type: "mobile", label: "Geschäftlich", kind: "geschaeftlich", key: "mobileWork" },
  { type: "email", label: "Privat", kind: "privat", key: "emailPrivate" },
  { type: "email", label: "Geschäftlich", kind: "geschaeftlich", key: "emailWork" },
];

/** Baut ContactCommunication-Einträge aus den getrennten Personen-Feldern. */
export function buildPersonCommItems(f: PersonCommFields): CommItem[] {
  let phoneDefaultSet = false;
  let emailDefaultSet = false;
  const out: CommItem[] = [];
  for (const spec of PERSON_COMM_SPECS) {
    const value = (f[spec.key] ?? "").trim();
    if (!value) continue;
    let isDefault = false;
    if ((spec.type === "phone" || spec.type === "mobile") && !phoneDefaultSet) {
      isDefault = true;
      phoneDefaultSet = true;
    } else if (spec.type === "email" && !emailDefaultSet) {
      isDefault = true;
      emailDefaultSet = true;
    }
    out.push({ type: spec.type, label: spec.label, kind: spec.kind, value, isDefault });
  }

  // Fallback für unqualifizierte Felder (z. B. einfache Masken wie Assistenz)
  if (!out.some((c) => c.type === "phone") && f.phone?.trim()) {
    out.push({
      type: "phone",
      label: "Geschäftlich",
      kind: "geschaeftlich",
      value: f.phone.trim(),
      isDefault: !phoneDefaultSet,
    });
    phoneDefaultSet = true;
  }
  if (!out.some((c) => c.type === "mobile") && f.mobile?.trim()) {
    out.push({
      type: "mobile",
      label: "Geschäftlich",
      kind: "geschaeftlich",
      value: f.mobile.trim(),
      isDefault: !phoneDefaultSet,
    });
    phoneDefaultSet = true;
  }
  if (!out.some((c) => c.type === "email") && f.email?.trim()) {
    out.push({
      type: "email",
      label: "Geschäftlich",
      kind: "geschaeftlich",
      value: f.email.trim(),
      isDefault: !emailDefaultSet,
    });
    emailDefaultSet = true;
  }

  return out;
}
